export const routesTanitim = [
  {
    path: "/geneltanitim",
    name: "geneltanitim",
    component: () => import("@/views/geneltanitim/index.vue"),
    meta: {
      public: false,
      title: "geneltanitim.Genel Tanıtım",
      yetki: { k: [1020202] },
    },
  },
 
]
